/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Chrome_ExtensionInputs */

const en_common_chrome_extension = /** @type {(inputs: Common_Chrome_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome Extension`)
};

const es_common_chrome_extension = /** @type {(inputs: Common_Chrome_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensión de Chrome`)
};

/**
* | output |
* | --- |
* | "Chrome Extension" |
*
* @param {Common_Chrome_ExtensionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_chrome_extension = /** @type {((inputs?: Common_Chrome_ExtensionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Chrome_ExtensionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_chrome_extension(inputs)
	return en_common_chrome_extension(inputs)
});